<template>
  <div>
    <List
      url="sre-api/deviceoffline/task/"
      :title="title"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :operat="operation"
      :update="updateList"
      :MultipleSel="true"
      :useBatchSuffix="false"
      @edit="edit"
      @deletedata="deletedata"
    >
    <div slot="Filter">
        <el-row :gutter="20">
          <el-col :span="24" style="margin-left:10px;margin-bottom:20px;">
            <el-button
              @click="add"
              type="primary"
              icon="el-icon-edit"
              >新增设备离线监控任务</el-button>
            <el-button @click="statistics" type="primary" style="margin-right:10px;">监控数据图表</el-button>
          </el-col>
        </el-row>
      </div>

      <div slot="Fresh" style="float:right;">
        <el-select multiple v-model="selectClouds" @change="search" placeholder="请选择云平台（多选）" style="width:200px;margin-right:10px;" size="small">
          <el-option
            v-for="cloud in cloudEnvList"
            :label="cloud"
            :key="cloud"
            :value="cloud"></el-option>
        </el-select>

        <el-input
          v-model="searchData.ins"
          @change="search"
          size="small"
          style="width:160px;margin-right:10px;"
          placeholder="请输入Ins账号"
        ></el-input>

        <el-input
          v-model="searchData.location"
          @change="search"
          size="small"
          style="width:160px;margin-right:10px;"
          placeholder="请输入社区名称"
        ></el-input>

        <el-input
          v-model="searchData.operator"
          @change="search"
          size="small"
          style="width:160px;margin-right:10px;"
          placeholder="请输入操作人"
        ></el-input>

        <el-select v-model="selectStatus" placeholder="选择任务状态" @change="search" style="width:120px;margin-right:10px;" size="small">
          <el-option value="全部" label="全部"></el-option>
          <el-option
            v-for="status in taskStatus"
            :label="status"
            :key="status"
            :value="status"></el-option>
        </el-select>
        <el-button @click="updateList++" type="primary" size="small">刷新列表</el-button>
      </div>

      <template v-slot:slot-switch="scope" >
         <el-switch v-model="scope.item.switchOriginValue" @change="changeSwicth($event,scope.item)"></el-switch>
      </template>
    </List>
    <SreApiDeviceOfflineTaskUpdateBox
      :initForm="updateForm"
      :updateType="updateType"
      :clouds="cloudEnvList"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
    ></SreApiDeviceOfflineTaskUpdateBox>
  </div>
</template>

<script>
import { TaskStatus } from "../components/Index/data.js";
import { DeviceTypes } from "../components/Index/data.js";

import List from "../components/common/List.vue";
import SreApiDeviceOfflineTaskUpdateBox from "../components/SreApi/SreApiDeviceOfflineTaskUpdateBox.vue";

export default {
  components: {
    List,
    SreApiDeviceOfflineTaskUpdateBox
  },
  data() {
    return {
      dialogFormVisible: false,
      selectStatus: "全部",
      taskStatus: TaskStatus,
      title: "设备离线监控任务",
      tanle: [
        { name: "cloud", label: "云平台" },
        { name: "ins", label: "Ins账号" },
        { name: "location", label: "社区名称" },
        { name: "device_type", label: "设备类型" },
        { name: "days", label: "监控天数（以修改时间为准）" },
        { name: "switch", label: "是否启用监控" },
        { name: "desc", label: "任务说明" },
        { name: "update_time", label: "修改时间" },
        { name: "operator", label: "操作人" }
      ],
      selectClouds: [],
      searchData: {
        cloud: "",
        ins: "",
        location: "",
        device_type: "",
        status: "",
        operator: ""
      },
      operation: [
        {
          text: "Edit",
          eventName: "edit"
        },
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ],

      updateList: 0,
      updateForm: {},
      cloudEnvList: [],
      updateType: "edit",
      updateBlock: false,
      token: ""
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.fetchCloudEnvs();
  },
  methods: {
    statistics(){
      window.open("http://grafana.akuvox.com/d/db19461e-2812-42db-bbbb-3ed3ea9b8160/e8aebe-e5a487-e7a6bb-e7babf-e79b91-e68ea7");
    },
    dealList(data) {
      for (let i in data) {
        data[i].create_time = this.changeDate(data[i].create_time);
        data[i].update_time = this.changeDate(data[i].update_time);
        data[i].switchOriginValue = Boolean(data[i].status);
        data[i].switch = data[i].status ? "启用" : "禁用";
        data[i].device_type_OriginValue = data[i].device_type;
        let deviceType = DeviceTypes.find(type => type.value === data[i].device_type);
        data[i].device_type = deviceType ? deviceType.name : '未知类型';
      }
      return data;
    },
    changeSwicth(changeValue,itemData){
      var params = {
        id: itemData.id,
        cloud: itemData.cloud,
        ins: itemData.ins,
        location: itemData.location,
        device_type: itemData.device_type_OriginValue,
        days: itemData.days,
        desc: itemData.desc,
        status: +(changeValue)
      };
      var url = "sre-api/deviceoffline/task/" + itemData.id + "/";
      this.$http["patch"](
        url,
        params,
        () => {
          this.$baseNotice.message("状态更新成功");
          this.updateList++;
        }
      );
    },
    close() {
      this.updateBlock = false;
    },
    edit(val) {
      this.updateForm = Object.assign({}, val);
      this.updateType = "edit";
      this.updateBlock = true;
    },
    add() {
      this.updateType = "add";
      this.updateForm = { switch: "启用", device_type: "社区设备", days: 30 };
      this.updateBlock = true;
    },
    search() {
      this.searchData.cloud = this.selectClouds.join(",");
      if (this.selectStatus === '全部') {
        this.searchData.status = "";
      } else {
        this.searchData.status = +(this.selectStatus === '启用');
      };
      this.updateList++;
    },
    deletedata(val) {
      this.$confirm('是否删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = "sre-api/deviceoffline/task/" + val.id + "/";
        this.$http["delete"](url,
          () => {
            this.$baseNotice.message("删除成功");
            this.updateList++;
          },
          () => {
            this.$message({message: "删除失败", type: "error"});
          }
        );
      }).catch(() => {
        this.$message({message: "已取消删除", type: "warning"});
      });
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    },
    fetchCloudEnvs() {
      this.$http["get"](
        "cloud/env/", {}, (data) => {
          this.cloudEnvList = data.data.results.map(item => item.cloud);
        }
      );
    }
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  }
};
</script>

<style lang="less" scoped>
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 20px;
  padding: 0px 16px;
  text-align: center;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
